import { render } from "./usergroupdetaileditor.vue?vue&type=template&id=1a7f3ca6&scoped=true"
import script from "./usergroupdetaileditor.vue?vue&type=script&lang=js"
export * from "./usergroupdetaileditor.vue?vue&type=script&lang=js"

import "./usergroupdetaileditor.vue?vue&type=style&index=0&id=1a7f3ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7f3ca6"]])

export default __exports__